var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-bar-chart',{ref:"chart5",style:({ width: _vm.width, height: _vm.height }),attrs:{"chart":"chart5"}})}
var staticRenderFns = []

export { render, staticRenderFns }